const COMMODITIES = [
  { name: 'Electricity', key: 'ELECTRICITY' },
  { name: 'Natural Gas', key: 'GAS' },
];

const CURRENCIES = [
  { name: 'US Dollars', key: 'USD' },
  { name: 'Australian Dollars', key: 'AUD' },
  { name: 'Canadian Dollars', key: 'CAD' },
];

const DAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

const DEVICE_CHARGE_STATUS = {
  CHARGING: 'Charging',
  NOT_CHARGING: 'Not Charging',
  FULLY_CHARGED: 'Fully Charged',
  default: '--',
};

const DEVICE_KINDS = {
  battery: 'Battery',
  circuitBreaker: 'Circuit Breaker',
  ev: 'Connected EV',
  evse: 'EV Charger',
  'evse-circuitBreaker': 'Circuit Breaker / EV Charger',
  hwh: 'Water Heater',
  rac: 'Room AC',
  tstat: 'HVAC',
  v2g: 'Vehicle to Grid',
  default: 'Unknown',
};

const DEVICE_MFGS = {
  aosmith: 'AO Smith',
  apricity: 'Apricity',
  aquanta: 'Aquanta',
  armada: 'Armada',
  chargepoint: 'ChargePoint',
  eaton: 'Eaton',
  ecobee: 'Ecobee',
  eguana: 'Eguana',
  emporia: 'Emporia',
  enelx: 'Enel X',
  eradio: 'eRadio',
  fermata: 'Fermata',
  flair: 'Flair',
  flo: 'Flo',
  ge: 'GE',
  honeywell: 'Honeywell Home',
  honeywellAcc: 'Amazon',
  honeywellTcc: 'Honeywell TCC',
  intesis: 'Intesis',
  juicebox: 'JuiceBox',
  juicenet: 'JuiceNet',
  nest: 'Google Nest',
  nri: 'Northern Reliability',
  pika: 'Generac',
  rheem: 'Rheem',
  sensibo: 'Sensibo',
  solaredge: 'SolarEdge',
  sonnen: 'sonnenBatterie',
  stash: 'Stash',
  sunverge: 'Sunverge',
  tesla: 'Tesla',
  tricklestar: 'TrickleStar',
  'vp-sim': 'VP Sim',
  default: 'Unknown',
};

const DEVICE_SUB_BRAND = {
  american: 'American',
  aosmith: 'AO Smith',
  lochinvar: 'Lochinvar',
  reliance: 'Reliance',
  state: 'State',
  uscraftmaster: 'U.S. Craftmaster',
  default: 'Unknown',
};

const EVENT_CATEGORY = {
  pre: 'Pre Event',
  event: 'Event',
  post: 'Post Event',
  notification: 'Notification',
  recurring: 'Recurring',
  default: 'Unknown',
};

const EVENT_INITIATOR = {
  'platoon-event': 'Platoon Event',
  schedule: 'Schedule',
  default: 'Ad Hoc',
};

const EVENT_TYPE = {
  hwh: 'Water Heater',
  tstat: 'HVAC',
  battery: 'Battery',
  v2g: 'Vehicle to Grid',
  rac: 'Room AC',
  evse: 'EV Charger',
  circuitBreaker: 'Circuit Breaker',
  'dr-event': 'Event Notification',
  'dr-ad-hoc': 'Event Notification',
  behavioral: 'Behavioral Event',
  email: 'Ad Hoc Message',
  default: 'Unknown',
};

const LINKED_ACCOUNT_TYPES = {
  aquanta: 'Aquanta API',
  arm: 'ARM',
  chargepoint: 'ChargePoint API',
  eaton: 'Eaton v2',
  ecobee: 'Ecobee API',
  eradio: 'e-Radio API',
  flair: 'Flair',
  flo: 'Flo API',
  ge: 'GE Connect Plus API',
  honeywell: 'Honeywell API',
  honeywellAcc: 'Amazon Smart Thermostat API',
  honeywellTcc: 'Honeywell TCC API',
  juicenet: 'JuiceNet API',
  nest: 'Nest Energy API',
  nri: 'Northern Reliability API',
  pika: 'Pika API',
  postgrid: 'PostGrid',
  rheem_partner: 'Rheem Partner API',
  sensibo: 'Sensibo API',
  sonnen: 'Sonnen V2 API',
  sunverge: 'Sunverge API',
  solaredge: 'SolarEdge API',
  tango: 'Tango',
  tesla: 'Tesla Powerwall API',
  'vp-sim': 'VP Sim',
  default: 'Unknown',
};

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const PAYMENT_TYPES = {
  GIFT_CARD: 'Gift Card',
  default: 'Unknown',
};

const STATE_NAMES = [
  { name: 'ALABAMA', abbreviation: 'AL' },
  { name: 'ALASKA', abbreviation: 'AK' },
  { name: 'AMERICAN SAMOA', abbreviation: 'AS' },
  { name: 'ARIZONA', abbreviation: 'AZ' },
  { name: 'ARKANSAS', abbreviation: 'AR' },
  { name: 'CALIFORNIA', abbreviation: 'CA' },
  { name: 'COLORADO', abbreviation: 'CO' },
  { name: 'CONNECTICUT', abbreviation: 'CT' },
  { name: 'DELAWARE', abbreviation: 'DE' },
  { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC' },
  { name: 'FEDERATED STATES OF MICRONESIA', abbreviation: 'FM' },
  { name: 'FLORIDA', abbreviation: 'FL' },
  { name: 'GEORGIA', abbreviation: 'GA' },
  { name: 'GUAM', abbreviation: 'GU' },
  { name: 'HAWAII', abbreviation: 'HI' },
  { name: 'IDAHO', abbreviation: 'ID' },
  { name: 'ILLINOIS', abbreviation: 'IL' },
  { name: 'INDIANA', abbreviation: 'IN' },
  { name: 'IOWA', abbreviation: 'IA' },
  { name: 'KANSAS', abbreviation: 'KS' },
  { name: 'KENTUCKY', abbreviation: 'KY' },
  { name: 'LOUISIANA', abbreviation: 'LA' },
  { name: 'MAINE', abbreviation: 'ME' },
  { name: 'MARSHALL ISLANDS', abbreviation: 'MH' },
  { name: 'MARYLAND', abbreviation: 'MD' },
  { name: 'MASSACHUSETTS', abbreviation: 'MA' },
  { name: 'MICHIGAN', abbreviation: 'MI' },
  { name: 'MINNESOTA', abbreviation: 'MN' },
  { name: 'MISSISSIPPI', abbreviation: 'MS' },
  { name: 'MISSOURI', abbreviation: 'MO' },
  { name: 'MONTANA', abbreviation: 'MT' },
  { name: 'NEBRASKA', abbreviation: 'NE' },
  { name: 'NEVADA', abbreviation: 'NV' },
  { name: 'NEW HAMPSHIRE', abbreviation: 'NH' },
  { name: 'NEW JERSEY', abbreviation: 'NJ' },
  { name: 'NEW MEXICO', abbreviation: 'NM' },
  { name: 'NEW YORK', abbreviation: 'NY' },
  { name: 'NORTH CAROLINA', abbreviation: 'NC' },
  { name: 'NORTH DAKOTA', abbreviation: 'ND' },
  { name: 'NORTHERN MARIANA ISLANDS', abbreviation: 'MP' },
  { name: 'OHIO', abbreviation: 'OH' },
  { name: 'OKLAHOMA', abbreviation: 'OK' },
  { name: 'OREGON', abbreviation: 'OR' },
  { name: 'PALAU', abbreviation: 'PW' },
  { name: 'PENNSYLVANIA', abbreviation: 'PA' },
  { name: 'PUERTO RICO', abbreviation: 'PR' },
  { name: 'RHODE ISLAND', abbreviation: 'RI' },
  { name: 'SOUTH CAROLINA', abbreviation: 'SC' },
  { name: 'SOUTH DAKOTA', abbreviation: 'SD' },
  { name: 'TENNESSEE', abbreviation: 'TN' },
  { name: 'TEXAS', abbreviation: 'TX' },
  { name: 'UTAH', abbreviation: 'UT' },
  { name: 'VERMONT', abbreviation: 'VT' },
  { name: 'VIRGIN ISLANDS', abbreviation: 'VI' },
  { name: 'VIRGINIA', abbreviation: 'VA' },
  { name: 'WASHINGTON', abbreviation: 'WA' },
  { name: 'WEST VIRGINIA', abbreviation: 'WV' },
  { name: 'WISCONSIN', abbreviation: 'WI' },
  { name: 'WYOMING', abbreviation: 'WY' },
];

const STATE_NAMES_AU = [
  { name: 'AUSTRALIAN CAPITAL TERRITORY', abbreviation: 'ACT' },
  { name: 'NEW SOUTH WALES', abbreviation: 'NSW' },
  { name: 'NORTHERN TERRITORY', abbreviation: 'NT' },
  { name: 'SOUTH AUSTRALIA', abbreviation: 'SA' },
  { name: 'TASMANIA', abbreviation: 'TAS' },
  { name: 'QUEENSLAND', abbreviation: 'QLD' },
  { name: 'VICTORIA', abbreviation: 'VIC' },
  { name: 'WESTERN AUSTRALIA', abbreviation: 'WA' },
];

const STATE_NAMES_CA = [
  { name: 'ALBERTA', abbreviation: 'AB' },
  { name: 'BRITISH COLUMBIA', abbreviation: 'BC' },
  { name: 'MANITOBA', abbreviation: 'MB' },
  { name: 'NEW BRUNSWICK', abbreviation: 'NB' },
  { name: 'NEWFOUNDLAND AND LABRADOR', abbreviation: 'NL' },
  { name: 'NORTHWEST TERRITORIES', abbreviation: 'NT' },
  { name: 'NOVA SCOTIA', abbreviation: 'NS' },
  { name: 'NUNAVUT', abbreviation: 'NU' },
  { name: 'ONTARIO', abbreviation: 'ON' },
  { name: 'PRINCE EDWARD ISLAND', abbreviation: 'PE' },
  { name: 'QUEBEC', abbreviation: 'QC' },
  { name: 'SASKATCHEWAN', abbreviation: 'SK' },
  { name: 'YUKON', abbreviation: 'YT' },
];

const TIME_ZONES = [
  { name: 'US/Eastern', value: 'America/New_York' },
  { name: 'US/Central', value: 'America/Chicago' },
  { name: 'US/Mountain', value: 'America/Denver' },
  { name: 'US/Pacific', value: 'America/Los_Angeles' },
  { name: 'US/Hawaii', value: 'Pacific/Honolulu' },
  { name: 'CA/Atlantic', value: 'America/Halifax' },
  { name: 'CA/Eastern', value: 'America/Toronto' },
  { name: 'AU/Western', value: 'Australia/Perth' },
  { name: 'AU/Central Western', value: 'Australia/Eucla' },
  { name: 'AU/Central', value: 'Australia/Adelaide' },
  { name: 'AU/Central NT', value: 'Australia/Darwin' },
  { name: 'AU/Eastern', value: 'Australia/Sydney' },
  { name: 'AU/Eastern QLD', value: 'Australia/Brisbane' },
  { name: 'AU/Lord Howe', value: 'Australia/Lord_Howe' },

];

const VEHICLE_MAKES = {
  ACURA: 'Acura',
  AUDI: 'Audi',
  BMW: 'BMW',
  BUICK: 'Buick',
  CADILLAC: 'Cadillac',
  CHEVROLET: 'Chevrolet',
  CHRYSLYER: 'Chrysler',
  DODGE: 'Dodge',
  FORD: 'Ford',
  GMC: 'GMC',
  HYUNDAI: 'Hyundai',
  JAGUAR: 'Jaguar',
  JEEP: 'Jeep',
  KIA: 'Kia',
  LAND_ROVER: 'Land Rover',
  LEXUS: 'Lexus',
  LINCOLN: 'Lincoln',
  MERCEDES_BENZ: 'Mercedes-Benz',
  MINI: 'MINI',
  NISSAN: 'Nissan',
  OPEL: 'Opel',
  PEUGEOT: 'Peugeot',
  RAM: 'RAM',
  RENAULT: 'Renault',
  TESLA: 'Tesla',
  TOYOTA: 'Toyota',
  VOLKSWAGEN: 'Volkswagen',
  VOLVO: 'Volvo',
  default: 'Unknown',
};

module.exports = Object.freeze({
  COMMODITIES,
  CURRENCIES,
  DAYS,
  DEVICE_CHARGE_STATUS,
  DEVICE_KINDS,
  DEVICE_MFGS,
  DEVICE_SUB_BRAND,
  EVENT_CATEGORY,
  EVENT_INITIATOR,
  EVENT_TYPE,
  LINKED_ACCOUNT_TYPES,
  MONTHS,
  PAYMENT_TYPES,
  STATE_NAMES,
  STATE_NAMES_AU,
  STATE_NAMES_CA,
  TIME_ZONES,
  VEHICLE_MAKES,
});
